import { ActionType } from 'src/types/common/common';

import { ResponsiveCarouselAdaptor } from 'src/constrains/DraggableModules/Components';
import { generateNewContentPage } from 'src/components/Modules/Components/ContentImageDragItem/tools';
import { randomNumber } from '@/src/tools/helper';

const ResponsiveContentPageCarouselFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnCarouselItemAdd = (id, data) => {
    const _n = { draggableId: randomNumber(), ...generateNewContentPage() };
    const _o = data || [_n];
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.add, id, data: _o });
    }
  };

  const handleOnCarouselItemDelete = (id, index) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.delete, id, data: { index } });
    }
  };

  const handleOnCarouselItemChange = (id, index, modifiedData) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.modify,
        id,
        data: {
          index,
          modifiedData,
        },
      });
    }
  };

  const handleOnCarouselItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: {
          from,
          to,
        },
      });
    }
  };

  const handleOnCarouselStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnCarouselModuleTypeChange = (data) => {
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };

  return {
    handleOnCarouselItemAdd,
    handleOnCarouselItemDelete,
    handleOnCarouselItemChange,
    handleOnCarouselItemSort,
    handleOnCarouselStaticChange,
    handleOnCarouselModuleTypeChange,
  };
};
const generateResponsiveContentPageCarousel = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const {
    handleOnCarouselItemAdd,
    handleOnCarouselItemDelete,
    handleOnCarouselItemChange,
    handleOnCarouselItemSort,
    handleOnCarouselStaticChange,
    handleOnCarouselModuleTypeChange,
  } = ResponsiveContentPageCarouselFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: ResponsiveCarouselAdaptor,
    props: {
      onItemAdd: handleOnCarouselItemAdd,
      onItemChange: handleOnCarouselItemChange,
      onItemSort: handleOnCarouselItemSort,
      onItemDelete: handleOnCarouselItemDelete,
      onStaticChange: handleOnCarouselStaticChange,
      onModuleTypeChange: handleOnCarouselModuleTypeChange,
    },
  };
};
export { generateResponsiveContentPageCarousel };
